import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0777cec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bg-gray-100 w-full",
  style: {"border-bottom":"1px solid transparent"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "w-full md:w-3/5 mx-auto",
  style: {"margin-top":"-10px","margin-bottom":"30px"}
}
const _hoisted_4 = {
  class: "w-full bg-white py-5 space-y-8",
  style: {"overflow":"hidden","padding-bottom":"64px"}
}
const _hoisted_5 = { class: "items2" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"desc-wrap\" data-v-e0777cec><div class=\"title\" data-v-e0777cec><p class=\"box\" data-v-e0777cec></p><span data-v-e0777cec>功能点介绍</span></div><div class=\"title1\" data-v-e0777cec><p class=\"p-text\" data-v-e0777cec>自定义部门管理</p><p class=\"p-text1\" data-v-e0777cec>部门工位切换自如，满足身兼多职的员工</p><p class=\"p-text1\" data-v-e0777cec>查看所在工位任务状态。</p></div></div>", 1)
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "items3" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "items4" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "desc-wrap" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"title1\" data-v-e0777cec><p class=\"p-box\" data-v-e0777cec></p><p class=\"p-text\" data-v-e0777cec>一键入、出库 操作便捷友好</p><p class=\"p-text1\" data-v-e0777cec>根据后台上传的菜谱自动生成采购任务，</p><p class=\"p-text1\" data-v-e0777cec>订单统计、采购分析、成本核算、费用管理等功能，</p><p class=\"p-text1\" data-v-e0777cec>一键生成生产及运营数据，满足生产标准化。</p></div>", 1)
const _hoisted_14 = { class: "title2" }
const _hoisted_15 = { class: "tit" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text" }, "任务日期", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text1" }, "滑动选择查看更多日期的任", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text1" }, "务。", -1))
const _hoisted_20 = { class: "title3" }
const _hoisted_21 = { class: "tit" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text" }, "一键入库", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text1" }, "食材采购任务可分批次一键入", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text1" }, "库，输入数量，系统自动计算", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text1" }, "任务是否已经完成。", -1))
const _hoisted_27 = { class: "title4" }
const _hoisted_28 = { class: "tit" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text" }, "拍照上传食材", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text1" }, "支持拍照上传采购食材，确保", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text1" }, "食材采购规范，部门之间沟通", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text1" }, "协调更高效。", -1))
const _hoisted_34 = { class: "items5" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "desc-wrap" }
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"title1\" data-v-e0777cec><p class=\"p-box\" data-v-e0777cec></p><p class=\"p-text\" data-v-e0777cec>备餐工作流程化</p><p class=\"p-text1\" data-v-e0777cec>实时掌握央厨生产过程每个环节工作进度，</p><p class=\"p-text1\" data-v-e0777cec>方便管理者随时随地对央厨信息化监督，从</p><p class=\"p-text1\" data-v-e0777cec>而有效规避风险。</p></div>", 1)
const _hoisted_38 = { class: "title2" }
const _hoisted_39 = { class: "tit" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text" }, "任务状态", -1))
const _hoisted_41 = ["src"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text1" }, "任务标记状态，任务是否完", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text1" }, "成，一目了然！", -1))
const _hoisted_44 = { class: "items6" }
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "items7" }
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "items8" }
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<div class=\"desc-wrap\" data-v-e0777cec><div class=\"title1\" data-v-e0777cec><p class=\"p-box\" data-v-e0777cec></p><p class=\"p-text\" data-v-e0777cec>奖励机制</p><p class=\"p-text1\" data-v-e0777cec>适当的奖励机制更好的激励员工，提高工作效率，提</p><p class=\"p-text1\" data-v-e0777cec>升员工积极性和满意度。</p></div></div>", 1)
const _hoisted_50 = ["src"]
const _hoisted_51 = { class: "items9" }
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"desc-wrap\" data-v-e0777cec><div class=\"title1\" data-v-e0777cec><p class=\"p-box\" data-v-e0777cec></p><p class=\"p-text\" data-v-e0777cec>平台规范化</p><p class=\"p-text1\" data-v-e0777cec>规范央厨生产过程每个环节，规避风险，提</p><p class=\"p-text1\" data-v-e0777cec>高生产效率。</p></div></div>", 1)
const _hoisted_53 = ["src"]
const _hoisted_54 = ["src"]
const _hoisted_55 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "",
      src: require('../../assets/prod-kxhgcd/kxhgcd-img1.jpg')
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("img", {
            class: "img2",
            src: require('../../assets/prod-kxhgcd/kxhgcd-img2.png')
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            class: "img3",
            src: require('../../assets/prod-kxhgcd/kxhgcd-img3.png')
          }, null, 8, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("img", {
            class: "img4",
            src: require('../../assets/prod-kxhgcd/kxhgcd-img4.png')
          }, null, 8, _hoisted_11),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", {
                  class: "icon-1",
                  src: require('../../assets/prod-kxhgcd/icon-1.png')
                }, null, 8, _hoisted_16),
                _hoisted_17
              ]),
              _hoisted_18,
              _hoisted_19
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("img", {
                  class: "icon-1",
                  src: require('../../assets/prod-kxhgcd/icon-1.png')
                }, null, 8, _hoisted_22),
                _hoisted_23
              ]),
              _hoisted_24,
              _hoisted_25,
              _hoisted_26
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("img", {
                  class: "icon-1",
                  src: require('../../assets/prod-kxhgcd/icon-1.png')
                }, null, 8, _hoisted_29),
                _hoisted_30
              ]),
              _hoisted_31,
              _hoisted_32,
              _hoisted_33
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("img", {
            class: "img5",
            src: require('../../assets/prod-kxhgcd/kxhgcd-img5.png')
          }, null, 8, _hoisted_35),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("img", {
                  class: "icon-1",
                  src: require('../../assets/prod-kxhgcd/icon-2.png')
                }, null, 8, _hoisted_41)
              ]),
              _hoisted_42,
              _hoisted_43
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("img", {
            class: "img6",
            src: require('../../assets/prod-kxhgcd/kxhgcd-img6.png')
          }, null, 8, _hoisted_45)
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("img", {
            class: "img7",
            src: require('../../assets/prod-kxhgcd/kxhgcd-img7.png')
          }, null, 8, _hoisted_47)
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("img", {
            class: "img8",
            src: require('../../assets/prod-kxhgcd/kxhgcd-img8.png')
          }, null, 8, _hoisted_50)
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("img", {
            class: "img9",
            src: require('../../assets/prod-kxhgcd/kxhgcd-img9.png')
          }, null, 8, _hoisted_53),
          _createElementVNode("img", {
            class: "img91",
            src: require('../../assets/prod-kxhgcd/kxhgcd-img91.png')
          }, null, 8, _hoisted_54),
          _createElementVNode("img", {
            class: "img92",
            src: require('../../assets/prod-kxhgcd/kxhgcd-img92.png')
          }, null, 8, _hoisted_55)
        ])
      ])
    ])
  ]))
}